import { Link } from "@mui/material";
import { GridCellParams } from "@mui/x-data-grid";
import { Link as RouterLink } from "react-router-dom";
import { Exam } from "../exam/type";

export default function ExamDetailButton(props: GridCellParams<Exam, any>) {
  return (
    <Link component={RouterLink} to={props.row.id.toString()}>
      Detay
    </Link>
  );
}
